<div class="stars-container" [class.clickable]="action" [matTooltip]="getTooltip()"
    [style.--star-color]="getStarColor()" (click)="onClick($event)">
    @for (star of stars; track $index) {
    @switch (star) {
    @case ("full") {
    <mat-icon class="star-full">star</mat-icon>
    }
    @case ("half") {
    <mat-icon class="star-half">star_half</mat-icon>
    }
    @case ("empty") {
    <mat-icon class="star-empty">star_outline</mat-icon>
    }
    }
    }
</div>